import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Textarea,
} from '@roger/ui-components';
import { Clipboard } from 'lucide-react';

interface SectionLayoutJsonDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  sectionDisplayName: string;
  value: string;
  onCopyLayoutJson: () => void;
}

/** Read-only view of a section's layout JSON. Layouts change through the MCP. */
export function SectionLayoutJsonDialog({
  open,
  onOpenChange,
  sectionDisplayName,
  value,
  onCopyLayoutJson,
}: SectionLayoutJsonDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='flex max-h-[min(90vh,52rem)] max-w-2xl flex-col'>
        <DialogHeader className='shrink-0'>
          <DialogTitle>Layout JSON — {sectionDisplayName}</DialogTitle>
          <DialogDescription>
            The Roger Layout Schema for this section.
          </DialogDescription>
        </DialogHeader>
        <Textarea
          value={value}
          readOnly
          aria-label='Layout JSON'
          className='min-h-[22rem] flex-1 font-mono text-[11px] leading-snug'
          spellCheck={false}
        />
        <DialogFooter className='shrink-0'>
          <Button
            type='button'
            variant='outline'
            onClick={onCopyLayoutJson}
            disabled={!value.trim()}
          >
            <Clipboard className='mr-1 h-3.5 w-3.5' aria-hidden />
            Copy
          </Button>
          <Button type='button' onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
